 const disableContent = () => {
    const listContainer = document.querySelectorAll('[data-test="listContainer"]')
    const tabsWrap: any = document.querySelectorAll('[data-test="tabs-wrap"]')
    for (let i = 0; i < tabsWrap.length; i++) {
      listContainer[i]?.classList?.add("is-disabled")
      tabsWrap[i]?.classList?.add("is-disabled")
    }
 }

 const enableContent = () => {
  const listContainer = document.querySelectorAll('[data-test="listContainer"]')
  const tabsWrap: any = document.querySelectorAll('[data-test="tabs-wrap"]')
  for (let i = 0; i < tabsWrap.length; i++) {
    listContainer[i]?.classList?.remove("is-disabled")
    tabsWrap[i]?.classList?.remove("is-disabled")
  }
 }

 const disabledFluidContent = () => {
  const contentFluid: any = document.querySelectorAll('[data-test="edit-content"]')
  for (let i = 0; i < contentFluid.length; i++) {
    contentFluid[i]?.classList?.add("is-disabled-fields")
  }
 }

 const enabledFluidContent = () => {
  const contentFluid: any = document.querySelectorAll('[data-test="edit-content"]')
  for (let i = 0; i < contentFluid.length; i++) {
    contentFluid[i]?.classList?.remove("is-disabled-fields")
  }
 }

 export { 
   disableContent, 
   enableContent,
   disabledFluidContent,
   enabledFluidContent
 }
